// The flat trip map (render 08): stages as stops on a yellow road. It's the Calm/low-battery
// view and the fallback when WebGL is unavailable. Layout comes from the pack's stage order.
import type { Pack } from '../../shared/pack/schema'
import { stageStatuses, type StageStatus } from '../domain/stages'
import type { TripClock } from '../domain/tripClock'
import { openOverlay } from '../app/router'

const FILL: Record<StageStatus, string> = { done: '#9AA9B8', now: '#FF4F4F', next: '#2F7BFF', later: '#FFFFFF' }

/** Points along a gentle rising road, left to right. */
function layout(n: number): { x: number; y: number }[] {
  const W = 350
  const pad = 30
  return Array.from({ length: n }, (_, i) => {
    const u = n === 1 ? 0.5 : i / (n - 1)
    return { x: pad + u * (W - pad * 2), y: 112 - u * 70 + Math.sin(u * Math.PI * 2) * 10 }
  })
}

export function FlatMap({ pack, clock }: { pack: Pack; clock: TripClock }) {
  const stages = pack.itinerary.stages
  const pts = layout(stages.length)
  const status = stageStatuses(stages, clock)
  const d = pts.reduce((acc, p, i) => {
    if (i === 0) return `M${p.x},${p.y}`
    const prev = pts[i - 1]!
    const mx = (prev.x + p.x) / 2
    return `${acc} C${mx},${prev.y} ${mx},${p.y} ${p.x},${p.y}`
  }, '')
  return (
    <svg viewBox="0 0 350 150" className="flat-map" role="img" aria-label="Trip stages">
      <path d={d} fill="none" stroke="#1B2A3A" strokeWidth="10" strokeLinecap="round" />
      <path d={d} fill="none" stroke="#FFC93C" strokeWidth="6" strokeLinecap="round" />
      {stages.map((s, i) => {
        const p = pts[i]!
        const big = status[i] === 'now'
        const below = i % 2 === 0
        return (
          <g key={s.id} className="flat-stop" onClick={() => openOverlay(`stage:${s.id}`)} role="button" aria-label={s.name}>
            <circle cx={p.x} cy={p.y} r={22} fill="transparent" />
            <circle cx={p.x} cy={p.y} r={big ? 15 : 12} fill={FILL[status[i]!]} stroke="#1B2A3A" strokeWidth="3" />
            <text x={p.x} y={below ? p.y + 30 : p.y - 20} textAnchor="middle" fontFamily="Fredoka" fontWeight="700" fontSize="12" fill="#1B2A3A">
              {s.shortName}
            </text>
          </g>
        )
      })}
    </svg>
  )
}
